<app-auth-layout>
    <h1 class="auth-title">Welcome back</h1>
    <p class="auth-subtitle">Sign in to continue your flip* journey.</p>

    <div class="registered-success text-center font-bold" *ngIf="registeredSuccess">
      Account created — please sign in.
    </div>

    <form
      [formGroup]="loginForm"
      (ngSubmit)="onSubmit()"
      class="form-container auth-page d-flex flex-column"
    >
      <div class="form-field-container">
        <label class="field-label">Email</label>
        <input
          class="pill-input"
          placeholder="Your registered email"
          formControlName="username"
          type="text"
        />
      </div>

      <div class="form-field-container">
        <label class="field-label">Password</label>
        <input
          class="pill-input"
          type="password"
          placeholder="Password"
          formControlName="password"
          id="password"
        />
      </div>

      <app-error-display
        *ngIf="error"
        [errorMessage]="error"
      ></app-error-display>

      <div
        class="login-actions d-flex flex-column align-items-center"
        [ngClass]="{ 'is-error': error }"
      >
        <div class="additional-actions d-flex justify-content-center">
          <a class="text-link" [routerLink]="['/reset-password']">
            Forgot password?
          </a>
        </div>

        <app-pill-button
          size="small"
          title="Log In"
          gradientFrom="var(--color-starlight)"
          gradientTo="var(--color-glacier)"
          textColor="var(--color-parchment)"
          [showForwardIcon]="false"
          [disabled]="!loginForm.valid"
          (clicked)="onSubmit()"
        ></app-pill-button>

        <div
          class="additional-actions d-flex justify-content-center create-account-link"
          *ngIf="mobileService.isMobileApp"
        >
          Don't have an account?
          <a class="text-link" [routerLink]="['/register']">Create one</a>
        </div>

        <div class="additional-actions create-account-link">
          By continuing, you agree to our <br/>
          <a
            class="text-link"
            href="https://legal.get-flipped.app/terms-of-use.html"
            rel="noopener noreferrer"
            (click)="openExternalLink($event, 'https://legal.get-flipped.app/terms-of-use.html')"
            >Terms of Use</a
          > and
          <a
            class="text-link"
            href="https://legal.get-flipped.app/privacy-policy.html"
            rel="noopener noreferrer"
            (click)="openExternalLink($event, 'https://legal.get-flipped.app/privacy-policy.html')"
            >Privacy Policy</a
          >
        </div>
      </div>
    </form>
</app-auth-layout>
